import React from 'react';
import './rating_popup.less';
import Rating from 'react-rating';
import DashBoardHeader from '../../header_dashboard/dashboard_header';
import ShowError from '../error/show_error';
import {routerActions} from 'react-router-redux';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import shipmentActions from '../../shipment/shipment_actions.jsx';
import {Link, browserHistory} from 'react-router';
import RatingComponent from '../rating/rating';
import classNames from 'classnames';
import CONSTANTS from '../../common_constants';
import validate from '../../util/validate';

class RatingPopup extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      user: props.user,
      reviewCount: 1,
      error: '',
      showCommentInput: false,
      isOpen: props.isOpen
    }
  }

  componentWillReceiveProps(newProps){
    this.setState({user: newProps.user,isOpen:newProps.isOpen})
  }

  onReviewUser = (review) => {
    this.setState({reviewCount: review});
  }

  onLeaveFeedback = () => {
    this.setState({showCommentInput: true});
  }

  reviewUserDone = (isComment) => {

      const self = this;
      const {props,state} = this;
      const {user} = state;

      if(isComment && !validate.name(state.comment)){
        this.setState({error: "Please add a valid comment."})
        return false;
      }

      if(state.reviewCount===0){
        this.setState({error: "Please rate the user."})
        return false;
      }

      let params = {
        shipmentId: user.shipmentId,
        reviewedFor: user.userId,
        rating: state.reviewCount,
        comment: state.comment,
        isShipper: user.isShipper
      }

      this.setState({isLoading: true});

      props.shipmentActions.addProfileReview(params).then(() => {
        self.setState({isLoading: false, error: ''},self.props.onClose());
      }, (errorRes) => {
        if (errorRes.error === CONSTANTS.sessionInvalid) {
          self.setState({isLoading: false});
          props.authActions.sessionValid(false);
          cookies.delete('_sd');
          return ;
        }else{
          self.setState({isLoading: false, error: errorRes.error})
        }
      });
    }

  onInputMessage(name, event) {
    let inputVal = event.target.value;

    if(inputVal.length>CONSTANTS.LEAVE_FEEDBACK_TEXT_LIMIT) {
      this.setState({
        error:"You have reached your maximum limit of characters allowed"
      });
      return false
    };
    this.setState({"comment": inputVal});
  }

  render(){
    const self = this;
    const {props,state} = this;
    const {user} = state;
    const imageUrl = user.imageUrl || "../../../public/images/user_placeholder.svg";

    return (
      <div className={state.isOpen ? "modal-popup rating-modal " : "displayNone"}>
        <div className="overlay"></div>
        <div className="modal rating-popup">
          {state.isLoading && <div className = "loader-wrapper"><div className = "loader"></div></div>}
          { state.error && <ShowError errorMessage={state.error}/> }
          <div className="close-button">
            <span className="icon-cross-feather cursor-pointer close-icn"
                  onClick={this.props.onClose}></span>
          </div>
          <div className="rating-title">Delivery Complete!</div>
          <div className="rating-description">{user.isShipper ? "Please take a moment to rate your experience.":"Payment will be released to your account in 24 hours. Please take a moment to rate your experience."}</div>
          <div className="profile-image-border">
            <div className="profile-image" style={{"backgroundImage": 'url(' + imageUrl + ')'}}></div>
          </div>
          <div className="profile-name">{user.name}</div>
          <RatingComponent
            rating={user.averageRating}
            ratingSize={"rating-size10"}/>
          <span className="reviewNumber">({user.totalNoOfRatings})</span>

          <div className="rating-wrap">
              <Rating
                start={0}
                top={5}
                step={1}
                empty={'icon-star-rounded-outline'}
                initialRate = {state.reviewCount}
                full={'icon-star-rounded-fill'}
                onClick = {this.onReviewUser}
              />
          </div>
          {
            state.showCommentInput && <input type = "text"
                                       placeholder = "Write your message here..."
                                       className = "modal-input comment-ip"
                                       onChange={this.onInputMessage.bind(self, 'comment')}
                                />
          }
          <div className="rating-btn-wrap">
            {
              !state.showCommentInput && <button className="btn orange rating-btn"
                      onClick = {() => this.onLeaveFeedback()}>
                      Leave Feedback</button>
            }
            <button className = {'btn rating-btn' + (state.showCommentInput ? " orange" : " green")}
                    onClick = {() => this.reviewUserDone(state.showCommentInput )}>
                    {state.showCommentInput ? "Send" : "Done"}
            </button>
          </div>
        </div>
      </div>
    )
  }
}

RatingPopup.propTypes = {
  user: React.PropTypes.object.isRequired
}

RatingPopup = connect( (state) => {
  return {}
}, (dispatch) => {
  return {
    shipmentActions: bindActionCreators(shipmentActions, dispatch)
  }
})(RatingPopup);

module.exports = RatingPopup;



// WEBPACK FOOTER //
// app/components/rating_popup/rating_popup.jsx